/* eslint-disable */
import { createApp } from "vue";
import { createPinia } from "pinia"; // Import
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router/router";
import VueSplide from "@splidejs/vue-splide";
import defaultImage from "@/assets/images/defaultImage.jpg";
import VueDatePicker from "@vuepic/vue-datepicker";
import Pagination from "v-pagination-3";
import "@vuepic/vue-datepicker/dist/main.css";
import { createI18n } from "vue-i18n";
// import { Language } from "./stores/Language";
import locales from "./locales/locales";
import axios from "axios";
import { createModal } from "@kolirt/vue-modal";
import vueClickOutsideElement from "vue-click-outside-element";
import VueObserveVisibility from 'vue3-observe-visibility';
import moment from 'moment';
import GeneralHelper from "./helpers/GeneralHelper";
// import { socket } from "./socket";
// import { CommonData } from "./stores/Common";

import { useInitializeStore } from "./stores/initialize";
import { useLanguagesStore } from './stores/languages';
import { useCustomerStore } from './stores/customer';
import { useMarketsStore } from './stores/markets';

import { useFavouritesStore } from "./stores/favourites";
import { useBannersStore } from "./stores/banners";
import { usePromotionsStore } from "./stores/promotions"
import { useVirtualCourtStore } from "./stores/virtual_court";
import { useBestlineVideoStore } from "./stores/bestline_video";
import { useGeneralStore } from "./stores/general";
import { MyBets } from "./stores/MyBets";
import { BetSlip } from './stores/BetSlip';
import { useMenuStore } from './stores/menus';
import { usePlatformConfigurationStore } from "./stores/platform_configuration";
import { useRuntimePopupStore } from "./stores/runtime_popup";
import { useAgentStore } from "./stores/agent";
import { openModal } from '@kolirt/vue-modal';
import SetLimitsModal from '@/components/modals/PlayerProtection/SetLimitsModal.vue';
import NotificationsModal from '@/components/modals/NotificationsModal.vue';
import NotificationsCarousel from "./components/modals/NotificationsCarousel.vue";
import Popper from "vue3-popper";
import Swal from "sweetalert2";
import sbSocketData from "./services/sbSocket";
import { useThemeStore } from "./stores/themes";
import { useBonusStore } from "./stores/bonus";
import { usePaymentGatewaysStore } from "./stores/payment_gateways";
import ShareBet from '@/components/modals/share_bet/ShareBetModal.vue';
import VersionUpdateModal from '@/components/modals/VersionUpdateModal.vue';
// Import the worker file
import Worker from './timer_worker.worker.js';
import packageJson from '../package.json';
import { useBetBoosterStore } from "./stores/bet_booster.js";

// Conditionally load vamos_extra styles
if (process.env.VUE_APP_API_URL && process.env.VUE_APP_API_URL.includes('24vamos')) {
	import('@/assets/scss/vamos_extra.scss');
}

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
	faWhatsapp,
	faFacebookF,
	faTelegram,
	faXTwitter,
	faInstagram
} from '@fortawesome/free-brands-svg-icons'

import { App as CapApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';


library.add(
	faWhatsapp,
	faFacebookF,
	faTelegram,
	faXTwitter,
	faInstagram
)

const worker = new Worker();

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(VueObserveVisibility)
app.use(pinia);

import { useSocketStore } from "./stores/socket";
const socketStore = useSocketStore();
// Vue Modal
app.use(
	createModal({
		transitionTime: 200,
		animationType: "slideDown",
		modalStyle: {
			align: "center",
			width: "100vw",
			height: "100vh",
			"max-width": "100vw",
			"z-index": 100000,
		},
		overlayStyle: {
			"background-color": "rgba(0, 0, 0, .5)",
			"z-index": 2000,
		},
	})
);

import { installLiveChat } from './plugins/live_chat';
import { installZendesk } from './plugins/zendesk';
import { useLaternaStore } from "./stores/laterna";
import emitter from "./helpers/emmiter";



const initializeStore = useInitializeStore();
const virtualCourtStore = useVirtualCourtStore();
const bestlineVideoStore = useBestlineVideoStore();
const menuStore = useMenuStore();
const runtimePopupStore = useRuntimePopupStore();
const platformConfigurationStore = usePlatformConfigurationStore();
const generalStore = useGeneralStore();
const themeStore = useThemeStore();
const bonusStore = useBonusStore();

const socketData = () => {

	// socketStore.getSocket.on('disconnect', () => {
	// 	console.log('Socket disconnected.');
	// 	// location.reload();
	// });

	/**
	 * Server timestamp clock tick
	*/
	socketStore.getSocket.on('server_timestamp', (data) => {
		initializeStore.setServerTimestamp(data);

		worker.postMessage({ initialTimestamp: data });
	});

	worker.onmessage = (event) => {
		initializeStore.setServerTimestamp(event.data);
	};

	emitter.on('productSettingsChanged', (data) => {
		router.push({ 'name': 'landing' });
	});

	if (bestlineVideoStore.isEnabled == true) {
		socketStore.join('videoUpdates');
	}
}

window.global = window;

global.axios = axios;
global.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// global.axios.defaults.withCredentials = true;

// Add a request interceptor to override Sportsbook API Language
global.axios.interceptors.request.use(function (config) {
	if (config.url && process.env.VUE_APP_SPORTSBOOK_API_URL && config.url.startsWith(process.env.VUE_APP_SPORTSBOOK_API_URL)) {
		config.headers = config.headers || {};
		config.headers['Accept-Language'] = useLanguagesStore().selectedSBLanguage.locale;
	}
	return config;
}, function (error) {
	return Promise.reject(error);
});

// Add a response interceptor
global.axios.interceptors.response.use(function (response) {
	return response;
}, function (error) {

	if (error.response) {
		if (error.response.status == 401) {
			useCustomerStore().emptyCustomer();
			try {
				MyBets().emptyMyBets();
				BetSlip().resetBetslip();
			} catch (error) {
				console.error(error.message || error);
			}
			window.location.href = '/';
		}

		if (error.response.status == 429) {
			setTimeout(() => {
				Swal.fire({
					text: 'Too many requests',
					icon: 'error',
					confirmButtonText: 'Close',
				});
			}, 100);
		}
	}

	return Promise.reject(error);
});


const mixins = {
	methods: {
		getImage(image_url) {
			if (!image_url) {
				return defaultImage;
			}
			return image_url;
		},
	},
};


const languagesStore = useLanguagesStore();
const marketsStore = useMarketsStore();
const customerStore = useCustomerStore();
const paymentGatewayStore = usePaymentGatewaysStore();
const favouritesStore = useFavouritesStore();
const bannersStore = useBannersStore();

let i18n = null;

async function initializeApp(device_type) {

	if (customerStore.auth_token) {
		global.axios.defaults.headers['Authorization'] = 'Bearer ' + customerStore.auth_token;
		await Promise.all([
			initializeStore.initialize(),
			customerStore.fetchCustomer()
		]);

		customerStore.fetchProtectionConfiguration();

		paymentGatewayStore.fetchCustomerPaymentGateways();

		customerStore.fetchProtectionLimits().then(() => {
			if (customerStore.customer && !customerStore.hasCustomerProtectionLimits) {
				if (platformConfigurationStore.isResponsibleBettingModalEnabled) {
					// agent brands have no player-protection section, so never prompt for limits
					if (!useAgentStore().agentEnabled) openModal(SetLimitsModal).catch(() => {});
				}
			}
		});

		bonusStore.fetchOffers();
	} else {
		await initializeStore.initialize();
		// Change language based on the ?lang=param
		const url_params = new URLSearchParams(window.location.search);
		const lang_param = url_params.get('lang');
		if (lang_param && languagesStore.getLanguages) {
			const matched_language = languagesStore.getLanguages.find(l => l.locale === lang_param);
			if (matched_language) {
				languagesStore.selected_language = matched_language;
			}
		}
	}

	const locale = languagesStore.selectedLanguage?.locale || 'en';
	global.axios.defaults.headers.common['Accept-Language'] = locale;
	global.axios.defaults.headers.common['Api-Language'] = locale;

	document.documentElement.setAttribute('lang', locale);
	if (['fa', 'ar', 'ckb', 'he'].includes(locale)) document.documentElement.setAttribute('dir', 'rtl');
	else document.documentElement.setAttribute('dir', 'ltr');

	usePromotionsStore().fetchPromotionCategories().then(() => {
		usePromotionsStore().selectPromotionCategory('all');
	});
	menuStore.fetchMenus(device_type);
	bannersStore.fetchHeroBanners();
	marketsStore.fetchOverviewMarkets();

	useBetBoosterStore().fetchBoostedBets();
	useLaternaStore().fetchLandingSections();
	return locale;
}

async function checkMobileVersion() {
	let version_data = await initializeStore.getVersionData();
	if (version_data && version_data.version && GeneralHelper.compareVersions(packageJson.app_version, version_data.version) < 0) {
		openModal(VersionUpdateModal, {
			download_url: version_data.url
		}).catch(() => { });
	}
}

function resolveLandingTarget(url) {
	if (!url) return null;

	try {
		const parsed = new URL(url, window.location.origin);
		// If external domain, do not leave site: return null to stay on home
		if (parsed.host !== window.location.host) return null;

		const path = parsed.pathname + parsed.search + parsed.hash;
		return path === '/' ? null : path;
	} catch (e) {
		return null;
	}
}

async function init(device_type) {
	const locale = await initializeApp(device_type);

	const initial_path = window.location.pathname;
	const landing_page = initializeStore.landing_page;

	if (initial_path === '/' && landing_page) {
		const target_path = resolveLandingTarget(landing_page);
		
		if (target_path) {
			const search = window.location.search;
			const final_path = search && !target_path.includes('?') ? target_path + search : target_path;

			await router.replace(final_path);
		}
	}
	
	if (Capacitor.isNativePlatform()) {
		try {
			await checkMobileVersion();
		} catch (error) {
			console.error(error.message || error);
		}
	}

	if (generalStore.getGeneral.theme_support) themeStore.applyColorThemeVariables();
	else initializeColors();

	handleCustomer();
	moment.locale(locale);
	// --- LiveChat Widget Injection Start ---
	app.use({ install: installLiveChat }, {
		chatEnabled: platformConfigurationStore.isLiveChatEnabled,
		provider: platformConfigurationStore.liveChatProvider,
		hideBubble: platformConfigurationStore.hideLiveChatBubble,
		crispWebsiteId: platformConfigurationStore.crispWebsiteId,
		talkToSrc: platformConfigurationStore.tawkToUrl,
		zendeskKey: platformConfigurationStore.zendeskKey,
		hooryWebsiteToken: platformConfigurationStore.hooryWebsiteToken,
		hooryBaseUrl: platformConfigurationStore.hooryBaseUrl,
	});
	// --- LiveChat Widget Injection End ---

	// --- ATHENA Pixel Injection Start ---
	if (platformConfigurationStore.isAthenaPixelEnabled) {
		if (!document.querySelector('script[data-athena-pixel="1"]')) {
			const pixelScript = document.createElement('script');
			pixelScript.src = 'https://media.athena-tech.eu/pixel.min.js';
			pixelScript.type = 'text/javascript';
			pixelScript.defer = true;
			pixelScript.setAttribute('data-athena-pixel', '1');
			pixelScript.onerror = function () {
				console && console.warn && console.warn('Athena Pixel: error loading script.');
			};
			document.body.appendChild(pixelScript);
		}
	}
	// --- ATHENA Pixel Injection End ---

	if (customerStore.isLoggedIn) runtimePopupStore.fetchAuthenticated();
	else runtimePopupStore.fetchUnauthenticated();

	if (bestlineVideoStore.isEnabled == true) bestlineVideoStore.fetchVideoEvents();
	socketStore.initializeSocket(languagesStore.selectedSBLanguage.locale);
	socketData();
	sbSocketData();

	if (customerStore.isLoggedIn) {
		favouritesStore.fetchFavourites().then(() => {
			favouritesStore.joinFavourites();
		});
	} else {
		favouritesStore.joinFavourites();
	}

	i18n = createI18n({
		locale: locale,
		fallbackLocale: 'en',
		messages: locales,
		legacy: false,
		globalInjection: true,
	});

	app.use({ install: installLiveChat }, {
		chatEnabled: process.env.VUE_APP_CHAT_ENABLED,
		talkToSrc: process.env.VUE_APP_TALK_TO,
	});

	app.mixin(mixins);
	app.use(i18n);
	app.use(router);
	app.use(VueSplide);
	app.use(vueClickOutsideElement);
	app.component('font-awesome-icon', FontAwesomeIcon)
	app.component("VueDatePicker", VueDatePicker);
	app.component('Popper', Popper);
	app.component("PaginaTion", Pagination);
	app.mount("#app");

	// Remove the ?lang= from the URL
	const url_params = new URLSearchParams(window.location.search);
	const lang_param = url_params.get('lang');

	if (lang_param) {
		router.isReady().then(() => {
			const current_params = new URLSearchParams(window.location.search);
			current_params.delete('lang');
			const clean_search = current_params.toString();
			const clean_url = window.location.pathname + (clean_search ? '?' + clean_search : '') + window.location.hash;
			window.history.replaceState(null, '', clean_url);
		});
	}

}

function handleCustomer() {
	global.axios.defaults.headers['Authorization'] = 'Bearer ' + customerStore.auth_token;
	if (customerStore.customer && customerStore.customer.browser_timezone == true) {
		const browser_timezone = moment().format('Z');
		if (customerStore.customer.timezone && customerStore.customer.timezone.utc_offset != browser_timezone) {
			customerStore.updateCustomerTimezone(browser_timezone);
		}

	}

	if (customerStore.customer && customerStore.getNumberOfUnreadDropdownNotification > 0) {
		openModal(NotificationsCarousel).catch(() => { });
	}
}

function initializeColors() {
	document.documentElement.style.setProperty('--dark-gray', generalStore.getGeneral.primary_color);
	document.documentElement.style.setProperty('--primary', generalStore.getGeneral.secondary_color);

	document.documentElement.style.setProperty('--dark', GeneralHelper.darkenHex(generalStore.getGeneral.primary_color, 0.15));
	document.documentElement.style.setProperty('--light-dark', GeneralHelper.lighten(generalStore.getGeneral.primary_color, 0.12));

	document.documentElement.style.setProperty('--light-primary', GeneralHelper.shift(generalStore.getGeneral.secondary_color, 15, 0, 6));
	document.documentElement.style.setProperty('--link-hover', GeneralHelper.darkenHex(generalStore.getGeneral.secondary_color, 0.35));
	document.documentElement.style.setProperty('--green-dark', GeneralHelper.darkenHex(generalStore.getGeneral.secondary_color, 0.49));

	document.documentElement.style.setProperty('--secondary', generalStore.getGeneral.third_color);
	document.documentElement.style.setProperty('--white', generalStore.getGeneral.primary_text_color);
	document.documentElement.style.setProperty('--text-secondary-color', generalStore.getGeneral.secondary_text_color);
	document.documentElement.style.setProperty('--odd-price-up', generalStore.getGeneral.odd_price_up_color);
	document.documentElement.style.setProperty('--odd-price-down', generalStore.getGeneral.odd_price_down_color);
	// document.documentElement.style.setProperty('--odd-background-color', generalStore.getGeneral.odd_color);
	// document.documentElement.style.setProperty('--linear-gradient-primary-color', generalStore.getGeneral.linear_gradient_primary);
	// document.documentElement.style.setProperty('--linear-gradient-secondary-color', generalStore.getGeneral.linear_gradient_secondary);
	document.documentElement.style.setProperty('--off-gray', generalStore.getGeneral.selector_background_color);

	document.documentElement.style.setProperty('--buttons-text-color', generalStore.getGeneral.buttons_text_color);

}


const device_type = menuStore.isMobile ? 'mobile' : 'desktop';
init(device_type);

let lastBackgroundTime = 0;

const handleAppResume = async () => {
	const socketStore = useSocketStore();
	const customerStore = useCustomerStore();

	const now = Date.now();
	const diff = now - lastBackgroundTime;

	console.log('App resumed after', diff, 'ms');

	if (socketStore.socket) {
		socketStore.socket.disconnect();
		socketStore.socket.connect();
	}

	if (diff > 10000 && customerStore.isLoggedIn) {
		console.log('Refreshing customer after inactivity');
		customerStore.fetchBalance();
		bonusStore.fetchOffers();
		MyBets().fetchMyBets();
	}

	if (diff > 300000) {
		console.log('Refreshing everythings after inactivity');
		initializeStore.initialize();
		bannersStore.fetchHeroBanners();
		marketsStore.fetchOverviewMarkets();
		menuStore.fetchMenus(device_type);
		useLaternaStore().fetchLandingSections();
		await checkMobileVersion();
	}
};

if (Capacitor.isNativePlatform()) {
	CapApp.addListener('appStateChange', ({ isActive }) => {
		if (!isActive) {
			lastBackgroundTime = Date.now();
		} else {
			handleAppResume();
		}
	});
}

export { i18n }
